import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useRouter } from "next/router";
import CategoryCard from "../CategoryCard";
import { useClient } from "@/hooks/useClient";

const CategoryGridSwiper = ({ handleSubCategoryData }) => {
  const { locale } = useRouter();
  const { isClient } = useClient();

  const activeInMegaCategories = handleSubCategoryData
    ?.filter((cat) => cat?.is_active && cat?.include_in_mega_menu)
    .slice(1);
  return (
    <>
      {handleSubCategoryData?.length && isClient ? (
        <Swiper
          key={locale}
          dir={locale === "en" ? "ltr" : "rtl"}
          breakpoints={{
            320: { slidesPerView: 2 },
            401: { slidesPerView: 2.5 },
            521: { slidesPerView: 3 },
            768: { slidesPerView: 4 },
            1044: { slidesPerView: 6 },
          }}
          spaceBetween={15}
          autoplay={{ delay: 3750 }}
          pagination={{ clickable: true }}
          modules={[Autoplay]}
          className="banner-swiper pb-9 max-sm:pb-16 sm:mb-6"
        >
          {activeInMegaCategories?.map((category) => (
            <SwiperSlide key={category?.id}>
              <CategoryCard fromCategory={category} />
            </SwiperSlide>
          ))}
        </Swiper>
      ) : null}
    </>
  );
};

export default CategoryGridSwiper;
